import {SoilTranslationsType} from './SoilsTranslationsType';

export const soilsTranslationsIt: SoilTranslationsType = {
  'soils.validation.min': 'Deve essere maggiore di 0',
  'soils.validation.max': 'Deve essere inferiore a 1',
  'soils.validation.rfu_ru': 'Campo obbligatorio',
  'soils.edit.rfu.error': 'Valore non valido',
  'soils.table.rfu_ru': 'RFU/RU',
  'arvalis.modal.title': 'Configura il tuo RAW/TAW con l aiuto di ARVALIS',
  'arvalis.modal.button.label': 'Simulatore ARVALIS',
  'soil.arvalis-modal.button.label': 'Come configurare il mio suolo se non ho un analisi completa?',
  'arvalis.modal.text1':
    'Non sai precisamente il tuo RAW/TAW? Clicca sul simulatore sviluppato da ARVALIS che ti aiuterà a definirli basandosi su alcuni criteri. Questo ti permetterà di migliorare la affidabilità delle raccomandazioni di irrigazione di Pixagri durante l intero campagna.',
  'arvalis.modal.text2':
    'Poi inserisci il valore di RU e la proporzione RAW/TAW quando crei il tuo suolo. Assicurati anche di selezionare la texture più vicina al tuo suolo.',
};
